import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatRegionSelector = createCustomElementWrapper('kat-region-selector', 'KatRegionSelector', {
    'maxHeight': 'max-height',
    'showClear': 'show-clear',
    'stateEmphasis': 'state-emphasis',
    'stateLabel': 'state-label',
}, {
    'onChange': 'change',
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});
